import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { ClientesServicios } from "../ClientesServicios/ClientesServicios";
import { ClientesTiendasServicios } from "../ClientesTiendasServicios/ClientesTiendasServicios";


export const ACTAsignarServicios: EntityClientAction = {
    name: 'ACTAsignarServicios',
    label: 'Asignar servicios',
    title: <Text fw={700}>Asignar servicios</Text>,
    refreshOnClose: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as ClientesTiendasServicios;
        const servicios = new ClientesServicios(entity.API.client);
        servicios.parentKeys = parent.parentKeys;

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Asignar servicios</Text>,
                    size: 'md'
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={servicios}
                    viewName={servicios.def.views.clse_brwStandard.name}
                    title="Asignar servicios seleccionados"
                    confirmContent="¿Está seguro de que desea asignar los servicios seleccionados a las tiendas seleccionadas?"
                    onActionFinished={async () => { if (onClose) await onClose(); }}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            if (selectedKeys && selectedKeys.length > 0) {
                                const clientes_tiendas_servicios = new ClientesTiendasServicios(entity.API.client, entity.parentKeys);
                                clientes_tiendas_servicios.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name] as string;

                                for (const key of selectedKeys ?? []) {
                                    clientes_tiendas_servicios.def.columns.c_tienda_id.value = key[clientes_tiendas_servicios.def.columns.c_tienda_id.name] as string;
                                    await clientes_tiendas_servicios.API.addData(abortSignal, keys, true);
                                }

                            }
                            return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                        }
                    }
                />

            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);

    }

}

